/**
 * Application route constants
 * Centralized route paths for type-safe navigation
 */
export const ROUTES = {
  // Public routes
  HOME: '/',
  AUTH: '/auth',
  FORGOT_PASSWORD: '/forgot-password',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  INSTALL: '/install',
  
  // Dashboard
  DASHBOARD: '/dashboard',
  OVERVIEW: '/overview',
  
  // Operations
  OPERATIONS_HUB: '/containers',
  CONTAINER_SETUP: '/container-setup',
  AI_COOKING_PLAN: '/ai-cooking-plan',
  
  // Smart Tongs
  TONGS_DEVICES: '/tongs-devices',
  TONGS_DURING_SERVICE: '/tongs-during-service',
  TONGS_ANALYTICS: '/analytics',
  TONGS_SIMULATOR: '/tongs-simulator',
  
  // Inventory & Menu
  INVENTORY: '/inventory',
  MENU_MANAGEMENT: '/menu',
  RECIPES: '/recipes',
  MENU_PRICING: '/menu-pricing',
  
  // Analytics & Insights
  AI_INSIGHTS: '/ai-insights',
  BUSINESS_ANALYTICS: '/business-analytics',
  BUSINESS_INSIGHTS: '/insights',
  COST_ANALYTICS: '/cost-analytics',
  PROFITABILITY: '/profitability',
  SUSTAINABILITY: '/sustainability',
  STAFF_ANALYTICS: '/staff-analytics',
  PREDICTIVE_ANALYTICS: '/predictive-analytics',
  SUPPLY_CHAIN: '/supply-chain',
  CUSTOMER_BEHAVIOR: '/customer-behavior',
  QUALITY_COMPLIANCE: '/quality-compliance',
  
  // Settings & Configuration
  BUSINESS_SETUP: '/business-setup',
  AI_CONFIGURATION: '/ai-config',
  INTEGRATIONS: '/integrations',
  SUBSCRIPTION: '/subscription',
  SETTINGS: '/settings',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = typeof ROUTES[RouteKey];
